import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import StaffReportView from "../components/staffReportView.jsx";
import Footer from "../components/footer.jsx";

function StaffReportViewPage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <StaffReportView/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default StaffReportViewPage;
